// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, enumOf, anyOf } from "@altostra/type-validations";
import { string, number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants.json";

export const isSmsMmsConsumptionResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      account: string,
      sms_type: enumOf(
        sharedConstants.MESSAGE_USAGE.SMS_TYPES.MMS,
        sharedConstants.MESSAGE_USAGE.SMS_TYPES.SMS,
        sharedConstants.MESSAGE_USAGE.SMS_TYPES.RCS_BASIC,
        sharedConstants.MESSAGE_USAGE.SMS_TYPES.RCS_SINGLE,
        sharedConstants.MESSAGE_USAGE.SMS_TYPES.RCS_RICH,
        sharedConstants.MESSAGE_USAGE.SMS_TYPES.RCS_RICH_MEDIA,
        sharedConstants.MESSAGE_USAGE.SMS_TYPES.BYO_SMS,
        sharedConstants.MESSAGE_USAGE.SMS_TYPES.BYO_MMS
      ),
      direction: enumOf("Inbound", "Outbound"),
      country: string,
      message_segments: anyOf(nullOrUndefined, number),
      message_count: anyOf(nullOrUndefined, number),
      credit_ratio: anyOf(nullOrUndefined, number),
      sms_credits_used: anyOf(nullOrUndefined, number),
      vendor: anyOf(nullOrUndefined, string),
      last_updated_at: number,
    })
  ),
});
